import { UPDATE_LIST } from '../../../integrations/list'
import { routesReducer as baseReducer } from '../../../integrations/routes'

/**
 * @typedef {import("../../../integrations/routes/reducer").RoutesState} RoutesState
 */

/**
 * @param {RoutesState} initialState
 * @returns {(state: RoutesState, action: Object) => RoutesState}
 */
export default function routesReducer(initialState) {
    return (state = initialState, action) => {
        state = baseReducer(state, action)
        return (action.type === UPDATE_LIST) ? action.data.routes : state
    }
}
